import React from "react";
import classNames from "classnames";

import { ReactComponent as ArrowSortIcon } from "static/icons/arrow-sort.svg";

import styles from "./styles.module.scss";

const DefaultColumnSorter = ({ column, className }) => {
  const sorted = column.getIsSorted();

  return (
    <button
      onClick={column.getToggleSortingHandler()}
      className={classNames(styles.btn, className)}
      style={{
        transition: "transform 0.25s",
        transform: `rotate(${sorted === "asc" ? "180" : "0"}deg)`,
      }}
      data-sorted={!!sorted}
    >
      <ArrowSortIcon />
    </button>
  );
};

export default DefaultColumnSorter;
